// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './assets/css/reset.css'
import { message, MessageBox } from 'element-ui'
import infiniteScroll from "vue-infinite-scroll";

import htmlToPdf from '@/common/htmltopdf'

Vue.use(infiniteScroll);

Vue.use(htmlToPdf)

// import ElementUi from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUi);

Vue.config.productionTip = false

Vue.prototype.$msg = (text,type="error")=>{
  message({
    type,
    showClose: true,
    message:text
  })
}

// Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$confirm = ({
  title='',msg='', conbtn='确定', canbtn='取消',type='warning',dangerouslyUseHTMLString=false
}) => {
  return new Promise((resolve,reject)=>{
    MessageBox.confirm(msg,title,{
      confirmButtonText: conbtn,
      cancelButtonText: canbtn,
      type,
      dangerouslyUseHTMLString
    }).then(() => {
      resolve();
    }).catch(()=>{
      reject();
    })
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js